module.exports = __webpack_public_path__ + "static/media/Stellar King Hydraulic Bed Base - 180x210 cm_Natural.6a25655b.png";